export enum FiltersActions {
    SET_SEARCH_PHRASE = "filter",
    TOGGLE_FILTRATION = "toggleFiltartion",
    ClEAR = "clear",
    SET_SORTING = "clear"
  }